import { makeStyles } from "@material-ui/styles"

const styles = makeStyles(theme => ({
  root: {},
  TextArea: {
    position: "relative",
    "& .MuiOutlinedInput-multiline": {
      padding: 0
    },
    "& textarea": {
      marginBottom: theme.spacing(4),
      padding: theme.spacing(2, 1.5)
    },
    "& .MuiInputAdornment-positionEnd": {
      position: "absolute",
      bottom: theme.spacing(2),
      right: theme.spacing(1.5),
      opacity: 0.34
    }
  },
  selectMember: {
    fontWeight: 700,
    margin: theme.spacing(2, 0)
  },
  sendButton: {
    marginTop: theme.spacing(2),
    width: 100
  },
  userList: {
    padding: theme.spacing(2, 0),
    fontSize: "16px",
    color: "#414141",
    opacity: 0.4
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationText/styles.js